var doc = document.implementation.createHTMLDocument('');
var div = doc.createElement('div');
function safeHTML(htmlString) {
  div.innerHTML = htmlString;
  for (
    var elements = div.querySelectorAll('*'), i = elements.length - 1;
    i >= 0;
    i--
  ) {
    var element = elements[i],
      tagName = element.localName;
 
    if (
      tagName == 'script' ||
      tagName == 'noscript' ||
      tagName == 'noembed' ||
      !(element.attributes instanceof NamedNodeMap)
    ) {
      try {
        element.parentNode.removeChild(element);
      } catch (e) {
        element.outerHTML = '';
      }
      continue;
    }
 
    if (!element.hasAttributes()) continue;
 
    for (
      var attributes = element.attributes, j = attributes.length - 1;
      j >= 0;
      j--
    ) {
      var attribute = attributes[j];
       var attributeName = attribute.localName;
      const regexPatternString =
        '[\\u0000-\\u0020\\u00A0\\u1680\\u180E\\u2000-\\u2029\\u205f\\u3000]';
        const regexFlags = 'g'; // Use 'g' for global matching
        const dynamicRegex = new RegExp(regexPatternString, regexFlags);
      var attributeValue = attribute.value
        .replace(dynamicRegex, '')
        .toLowerCase()
        .trim();
      // Remove insecure attribute starting "on*" (example: <img src='' onerror=alert(1)>)
      if (attributeName.indexOf('on') == 0)
        element.removeAttribute(attributeName);
      // Remove insecure src/href attribute with value starting "javascript:*" (example: href="javascript:alert(1)")
      else if (
        (attributeName == 'src' || attributeName == 'href') &&
        attributeValue.indexOf('javascript:') == 0
      )
        element.removeAttribute(attributeName);
      // For non-specific tags remove insecure src/data attribute with value starting "data:*" (example: <embed src="data:text/html;base64,PHNjcmlwdD5hbGVydCgxKTwvc2NyaXB0Pg==">)
      else if (
        ['audio', 'image', 'img', 'source', 'video'].indexOf(tagName) == -1 &&
        (attributeName == 'src' || attributeName == 'data') &&
        attributeValue.indexOf('data:') == 0
      )
        element.removeAttribute(attributeName);
    }
  }
  return div.innerHTML;
}
export const htmlsafe = {
  name: 'htmlsafe',
  inserted: function (el, binding) {
    el.innerHTML = safeHTML(binding.value);
  },
};
 